import React from "react";

function AboutShort2() {
  return (
   <section id="about"> 
     <div className="flex mb-8 flex-col items-center justify-center mt-10 text-center px-4" >
      <h1 className="text-4xl font-bold mb-4">درباره ما</h1>
      <p className="w-full px-2 sm:px-10 md:px-20 lg:px-40 text-right text-[1.20rem] leading-loose text-gray-500 font-light">
        شرکت هوشمند پرداز هاویر با نام تجاری هاویر (Havir) از سال 1399 فعالیت
        خود را بصورت رسمی در حوزه های امنیت سایبری و هوش مصنوعی و تولید سامانه
        ها آغاز کرد. این شرکت توانسته است با بهره گیری از آخرین فناوری های روز و
        بکارگیری نیروهای انسانی متخصص در داخل کشور محصولات و خدمات متنوعی در
        حوزه های مختلف فناوری اطلاعات عرضه کند. از مهمترین محصولات این شرکت می
        توان سامانه پایش خودکار آسیب پذیری ها، سامانه واسط مودیان مالیاتی،
        سامانه مدیریت دارایی های فناوری اطلاعات و سامانه توزیع نهاده های دامی را
        نام برد. این محصولات هم اکنون در حال سرویس دادن به مشتریان حقیقی و حقوقی
        می باشند. این شرکت همچنین در پروژه های تست و ارزیابی امنیتی پورتال ها و
        وب سایت ها، ارزیابی و ارتقاء امنیت اپلیکیشن های بانکی، درگاههای پرداخت
        خدمات زیادی را به ارگان های خصوصی و دولتی کشور ارائه کرده است. هاویر تک
        توسط اعضای هیئت علمی گروه مهندسی کامپیوتر دانشگاه لرستان و اعضای هیئت
        علمی گروه مهندسی کامپیوتر دانشگاه بوشهر بنیان گذاری و تاسیس شده است. با
        توجه به نیازهای مرتبط با فناوری اطلاعات در دو استان لرستان و بوشهر،
        دفاتر هاویرتک در هر دو استان راه اندازی شده است. هاویرتک زیر نظر پارک
        علم و فناوری استان لرستان، مرکز نوآوری دانشگاه لرستان و مرکز رشد و
        نوآوری دانشگاه خلیج بوشهر فعالیت می کند. در زمینه امن سازی زیرساخت های
        حیاتی کشور، پروژه های زیادی در سالهای گذشته توسط شرکت با موفقیت به انجام
        شده است. این پروژه ها شامل ارزیابی و ارتقاء امنیت اپلیکیشن های بانکی،
        درگاههای پرداخت و پورتال های اطلاع رسانی بانک های کشور، می باشند.
      </p>
    </div>
   </section>
  );
}

export default AboutShort2;
